import { jsxs, jsx } from 'react/jsx-runtime';
import { useModelCompareTranslation } from '../../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import { useMenu } from '../../../../../../contexts/MenuContext/context.mjs';
import { imageSrc } from '../../../../../../utils/asset.mjs';
import { Reveal } from '../../../../../Reveal/Reveal.mjs';
import { EmptyHeaderGridItem, HeaderGridItemContainer, ProductImageWrap, ProductImage, ProductDescription, SelectFromAboveIsStuckContainer, SelectFromAboveIsStuck } from '../../../CompareTable.styles.mjs';
"use strict";
const EmptyColumnHeader = ({
  product,
  index,
  hasBeenObserved,
  maxImageHeight,
  headerItemsAreSticking
}) => {
  const {
    formatMessage
  } = useModelCompareTranslation();
  const {
    languageDirection
  } = useMenu();
  return /* @__PURE__ */jsxs(EmptyHeaderGridItem, {
    children: [/* @__PURE__ */jsx(Reveal, {
      index,
      playAnimation: hasBeenObserved,
      children: /* @__PURE__ */jsxs(HeaderGridItemContainer, {
        style: {
          height: `${maxImageHeight}px`
        },
        $isStuck: headerItemsAreSticking,
        children: [/* @__PURE__ */jsx(ProductImageWrap, {
          height: product.image.height,
          children: /* @__PURE__ */jsx(ProductImage, {
            src: imageSrc(product.image.src),
            width: product.image.width,
            alt: formatMessage(product.title)
          })
        }), /* @__PURE__ */jsx(ProductDescription, {
          $maxWidth: product.descriptionMaxWidth,
          $direction: languageDirection,
          children: formatMessage("commons.emptyColumn.description")
        })]
      })
    }), /* @__PURE__ */jsx(SelectFromAboveIsStuckContainer, {
      $isStuck: headerItemsAreSticking,
      children: /* @__PURE__ */jsx(SelectFromAboveIsStuck, {
        $maxWidth: product.descriptionMaxWidth,
        $direction: languageDirection,
        children: formatMessage("commons.emptyColumn.description")
      })
    })]
  });
};
export { EmptyColumnHeader };
//# sourceMappingURL=EmptyColumnHeader.mjs.map
